import { useLocation, useParams } from 'react-router';
import { useReceivedDocByMark } from '../../api/hooks/receivedDocs/useReceivedDocByMark';
import { Loading } from '../../components/atoms/Loading';
import { DeliveryStatusGsisDoc } from '../Delivery/component/DeliveryStatusGsisDoc';
import { AadeBookInvoiceType } from '../../interfaces/myData.interface';

export const ReceivedDocScreen = () => {
  const { mark } = useParams<{ mark: string }>();
  const location = useLocation();
  const stateDoc = (location.state as { doc?: AadeBookInvoiceType } | null)?.doc;

  const { data, isLoading } = useReceivedDocByMark(mark, !stateDoc);

  const doc = stateDoc ?? data ?? null;

  if (isLoading) return <Loading backgroundFull />;
  if (!doc) return null;

  return (
    <div className="scrollable width-100 flex-start-center-column-nowrap p-t-16 p-b-16 p-r-24 p-l-24">
      <DeliveryStatusGsisDoc doc={doc} />
    </div>
  );
};
